import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

type Variants = 'blue';

@Component({
  imports: [NgClass],
  selector: 'aux-badge',
  template: `
    <div class="badge-container w-fit rounded border px-2" [ngClass]="className">
      {{ title }}
    </div>
  `,
})
export class BadgeComponent {
  _className = '';
  _variant: Variants = 'blue';
  @Input({ required: true }) title!: string;

  private variants: Record<Variants, string> = {
    blue: 'border-aux-blue-light-4 bg-aux-blue-light-3 text-aux-blue-dark-2',
  };

  get className() {
    return `${this._className} ${this.variants[this.variant]}`;
  }

  @Input() set className(classes: string) {
    this._className = classes;
  }

  get variant(): Variants {
    return this._variant || 'blue';
  }

  @Input({ required: true }) set variant(theme: Variants) {
    this._variant = theme;
  }
}
